import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  divBackground: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#F5F6F9",
  },
  divHeader: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  divTitle:{
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginBottom: "50px"
  },
  divByPolko: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginBottom: "80px"
  },
  iconCircle: {
    clipPath: "circle(25px at 50% 50%)",
    background:"#bb0d66",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-50px",
    height: "50px"
  },
  divFormTitle: {
    display: "flex",
    flexDirection: "row",
    fontSize: "18px",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "30px",
  },
  formBox: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    width:"800px",
    boxShadow: "5px 10px 18px #888888",
    padding:"30px"
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  buttonContained: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#BB0D66",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  buttonBack: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
  step: {
    "& $completed": {
      color: '#452d7b'
    },
    "& $active": {
      color: '#452d7b'
    },
  },
  active: {},
  completed: {},
  alert: {
    backgroundColor: theme.palette.warning.dark
  },
}));
